<qpx-controls
    [zoom]="zoom()"
    [controlsVisible]="controlsVisible()"
    [documentInfoVisible]="documentInfoVisible()"
    [handTool]="handTool()"
    [actions]="actions()"
    [leftPanels]="leftPanels()"
    [rightPanels]="rightPanels()"
    [activeLeftPanelId]="activeLeftPanelId()"
    [activeRightPanelId]="activeRightPanelId()"
    (zoomOut)="onImageZoomOut()"
    (zoomIn)="onImageZoomIn()"
    (zoomReset)="onImageZoomReset()"
    (zoomSelect)="onImageZoomSelect($event)"
    (rotateClockwise)="onImageRotateClockwise()"
    (handToolToggle)="onImageHandToolToggle()"
    (controlsToggle)="onControlsToggle()"
    (infoToggle)="onDocumentInfoToggle()"
    (panelToggle)="onPanelToggle($event)"
    (download)="onImageDownload()"
    (closePreview)="closePreview.emit()"
/>

<qpx-image-renderer
    [source]="previewUrl()"
    alternativeText="Document preview"
    [width]="imageWidth()"
    [height]="previewHeight()"
    [maxWidth]="imageMaxWidth()"
    [maxHeight]="imageMaxHeight()"
    objectFit="contain"
    [rotation]="imageRotation()"
    [handTool]="handTool()"
    (viewerLoaded)="viewerLoaded.emit()"
    (viewerLoadError)="viewerLoadError.emit($event)"
    (pointerDown)="onImagePointerDown($event)"
    (pointerMove)="onImagePointerMove($event)"
    (pointerEnd)="onImagePointerUp($event)"
/>

@if (controlsVisible()) {
    @if (activeLeftPanel(); as panel) {
        @if (!panelsMountedByHost() || !panel.retainOnSourceChange) {
            <qpx-preview-panel
                [side]="FILE_PREVIEW_PANEL_SIDE.Left"
                [panelId]="panelId(panel)"
                [fileName]="fileName()"
                [panel]="panel"
            />
        }
    }

    @if (activeRightPanel(); as panel) {
        @if (!panelsMountedByHost() || !panel.retainOnSourceChange) {
            <qpx-preview-panel
                [side]="FILE_PREVIEW_PANEL_SIDE.Right"
                [panelId]="panelId(panel)"
                [fileName]="fileName()"
                [panel]="panel"
            />
        }
    } @else if (documentInfoVisible()) {
        <qpx-preview-panel
            [side]="FILE_PREVIEW_PANEL_SIDE.Right"
            [panelId]="documentInfoPanelId"
            [fileName]="fileName()"
            [panel]="infoPanel()"
        />
    }
}
